import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import React from 'react';
import { ChildrenProps } from '../../../common/interfaces/childrenProps';
import { RaterStyles } from '../../styles/rater';

export const RaterCard = ({ children }: ChildrenProps): React.JSX.Element => {
  const { classes } = RaterStyles();

  return (
    <Card variant="outlined" className={classes.raterCard}>
      <CardContent className={classes.raterCardContent}>{children}</CardContent>
    </Card>
  );
};
